var _excluded = ["title", "subtitle", "titleClassName", "subtitleClassName"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import './sectionHeader.scss';
var SectionHeader = function SectionHeader(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    titleClassName = _ref.titleClassName,
    subtitleClassName = _ref.subtitleClassName,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: "SectionHeader d-flex flex-column mb-0"
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "section-header-title ".concat(titleClassName)
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "text text-muted"
  }, subtitle));
};
SectionHeader.defaultProps = {
  titleClassName: "fs-5",
  subtitleClassName: undefined
};
export default SectionHeader;